import { createAction, makeActionTrackable } from '@lingoda/core';

export default makeActionTrackable(createAction('user/FETCH_ME'));
